import { render, staticRenderFns } from "./BalancesPlanDetailsAdd.vue?vue&type=template&id=ba447352&scoped=true&"
import script from "./BalancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba447352",
  null
  
)

export default component.exports